var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.PatSnapAvatarRenderer,{ref:"userRef",staticClass:"patsnap-user-avatar rounded-full text-white",attrs:{"avatar":_setup.avatar}})
}
var staticRenderFns = []

export { render, staticRenderFns }